import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

const Loader = () => (
  <div>
    <ClipLoader color="#86EFAC" />
  </div>
);

export default Loader;
